import React, { useEffect, useState } from "react";
import banner from "../Assets/Images/homebanner.jpg";
import ApiRequest from "../Common/restservice";
import { errorToast, successToast } from "../Common/showtoast";
import { Link, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
function Register() {
  const navigate = useNavigate();
  const { type } = useParams();
  const [categories, setCategories] = useState([]);
  const [stateObj, setStateObj] = useState({
    usertype: "freelancer",
    usertypecategory: "Individual",
  });
  useEffect(() => {
    setStateObj({ ...stateObj, usertype: type });
  }, [type]);
  // const GetCategories = async (e) => {
  //   let res = await ApiRequest("GetCategory.asp", "GET", null);
  //   if (res.status === "error") {
  //     errorToast(res.message);
  //     return;
  //   }
  //   setCategories(res.items);
  // };
  const OnSendOtp = async (e) => {
    if (!stateObj.email) {
      errorToast("Enter valid email");
      return;
    }
    let jsoninput = {
      email: stateObj.email,
    };
    let res = await ApiRequest(
      "send_otp_signup.asp",
      "POST",
      JSON.stringify(jsoninput)
    );
    if (res.status === "error") {
      errorToast(res.message);
      return;
    }
    successToast(res.message);
  };
  const OnSendMobileOtp = async (e) => {
    if (!stateObj.mobile) {
      errorToast("Enter valid mobile");
      return;
    }
    let jsoninput = {
      mobile: stateObj.mobile,
    };
    let res = await ApiRequest(
      "send_mobileotp_signup.asp",
      "POST",
      JSON.stringify(jsoninput)
    );
    if (res.status === "error") {
      errorToast(res.message);
      return;
    }
    successToast(res.message);
  };
  const OnRegister = async (e) => {
    e.preventDefault();
    if (!stateObj.fullname) {
      errorToast("Enter valid fullname");
      return;
    } else if (!stateObj.dob) {
      errorToast("Enter valid date of birth");
      return;
    } else if (!stateObj.email) {
      errorToast("Enter valid email");
      return;
    } else if (!stateObj.mobile) {
      errorToast("Enter valid mobile");
      return;
    } else if (!stateObj.mobileotp) {
      errorToast("Enter valid mobile otp");
      return;
    } else if (!stateObj.otp) {
      errorToast("Enter valid email otp");
      return;
    } else if (!stateObj.password) {
      errorToast("Enter valid password");
      return;
    } else if (!stateObj.confirmpassword) {
      errorToast("Enter valid confirmpassword");
      return;
    } else if (stateObj.password !== stateObj.confirmpassword) {
      errorToast("Password Mismatched");
      return;
    } else if (!stateObj.terms) {
      errorToast("Please read and accept terms and conditions");
      return;
    }
    let jsoninput = {
      email: stateObj.email,
      mobile: stateObj.mobile,
      password: stateObj.password,
      fullname: stateObj.fullname,
      usertype: stateObj.usertype,
      usertypecategory: stateObj.usertypecategory,
      otp: stateObj.otp,
      mobileotp: stateObj.mobileotp,
      dob: moment(stateObj.dob).format("MM/DD/YYYY"),
    };
    const regex = /['&;\-]/g;
    let data = JSON.stringify(jsoninput).replace(regex, "");
    let res = await ApiRequest("actReg.asp", "POST", data);
    if (res.status === "error") {
      errorToast(res.message);
      return;
    }
    successToast(res.message);
    await Swal.fire({
      title: "Registered Successfully",
      icon: "success",
      html: `<div class='text-center'><label class='mb-3'>Please notedown your userid and password for the future purpose.</label><br><p>Email : <span class='text-primary'>${stateObj.email}</span></p><p>Username : <span class='text-primary'>${res.username}</span></p><p>Password : <span class='text-primary'>${stateObj.password}</span></p></div>`,
    });
    navigate("/login");
  };
  return (
    <>
      <section>
        <div
          className="bannerimg cover-image bg-background3"
          data-bs-image-src={banner}
          style={{ background: `url(${banner}) center 25%` }}
        >
          <div className="header-text mb-0">
            <div className="container">
              <div className="text-center text-white">
                <h1>Register</h1>
                <ol className="breadcrumb text-center">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li
                    className="breadcrumb-item active text-white"
                    aria-current="page"
                  >
                    Register
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sptb">
        <div className="container customerpage">
          <div className="row">
            <div className="single-page">
              <div className="col-lg-7 col-xl-6 col-md-6 d-block mx-auto">
                <div className="wrapper wrapper2">
                  <form className="card-body" onSubmit={OnRegister}>
                    <h3>Register</h3>
                    <div className="form-group">
                      <label className="form-label text-dark text-start">
                        User Type :<span className="text-danger">*</span>
                      </label>
                      <div className="d-md-flex ad-post-details">
                        <label className="custom-control form-radio mb-2 me-4">
                          <input
                            id="marketer"
                            value="freelancer"
                            type="radio"
                            className="custom-control-input"
                            name="classiera_user_type"
                            checked={stateObj.usertype === "freelancer"}
                            onChange={(e) =>
                              setStateObj({
                                ...stateObj,
                                usertype: e.target.value,
                              })
                            }
                          />
                          <span
                            className="custom-control-label text-muted"
                            htmlFor="marketer"
                          >
                            Freelance Marketer
                          </span>
                        </label>
                        <label className="custom-control form-radio mb-2 me-4">
                          <input
                            id="provider"
                            value="company"
                            type="radio"
                            className="custom-control-input"
                            name="classiera_user_type"
                            checked={stateObj.usertype === "company"}
                            onChange={(e) =>
                              setStateObj({
                                ...stateObj,
                                usertype: e.target.value,
                              })
                            }
                          />
                          <span
                            className="custom-control-label text-muted"
                            htmlFor="provider"
                          >
                            Business
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label text-dark text-start">
                        User Type Category:
                        <span className="text-danger">*</span>
                      </label>
                      <div className="d-md-flex ad-post-details">
                        <label className="custom-control form-radio mb-2 me-4">
                          <input
                            id="Individual"
                            value="Individual"
                            type="radio"
                            className="custom-control-input"
                            name="classiera_user_type_category"
                            checked={stateObj.usertypecategory === "Individual"}
                            onChange={(e) =>
                              setStateObj({
                                ...stateObj,
                                usertypecategory: e.target.value,
                              })
                            }
                          />
                          <span
                            className="custom-control-label text-muted"
                            htmlFor="Individual"
                          >
                            Individual
                          </span>
                        </label>
                        <label className="custom-control form-radio mb-2 me-4">
                          <input
                            id="Company"
                            value="Company"
                            type="radio"
                            className="custom-control-input"
                            name="classiera_user_type_category"
                            checked={stateObj.usertypecategory === "Company"}
                            onChange={(e) =>
                              setStateObj({
                                ...stateObj,
                                usertypecategory: e.target.value,
                              })
                            }
                          />
                          <span
                            className="custom-control-label text-muted"
                            htmlFor="Company"
                          >
                            Company
                          </span>
                        </label>
                      </div>
                    </div>
                    {/* <div className="email">
                      <select
                        className="form-control"
                        onChange={(e) =>
                          setStateObj({
                            ...stateObj,
                            category: e.target.value,
                          })
                        }
                        value={stateObj.category}
                      >
                        <option value={""}>--Select Industry--</option>
                        {categories.map((item) => {
                          return (
                            <option value={item.Category}>
                              {item.Category}
                            </option>
                          );
                        })}
                      </select>
                      <label>Industry</label>
                    </div> */}
                    <div className="email">
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) =>
                          setStateObj({
                            ...stateObj,
                            fullname: e.target.value,
                          })
                        }
                        value={stateObj.fullname}
                      />
                      <label>Full name</label>
                    </div>
                    <div className="email">
                      <input
                        type="date"
                        max={moment()
                          .subtract(18, "years")
                          .format("YYYY-MM-DD")}
                        className="form-control"
                        onChange={(e) => {
                          if (
                            moment(e.target.value) <=
                            moment().subtract(18, "years")
                          )
                            setStateObj({
                              ...stateObj,
                              dob: e.target.value,
                            });
                        }}
                        value={stateObj.dob}
                      />
                      <label>Date of Birth</label>
                    </div>
                    <div className="email">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) =>
                            setStateObj({
                              ...stateObj,
                              mobile: e.target.value,
                            })
                          }
                          value={stateObj.mobile}
                        />
                        <div className="input-group-apppend">
                          <span
                            className="input-group-text mt-2"
                            onClick={() => OnSendMobileOtp()}
                          >
                            Send OTP
                          </span>
                        </div>
                      </div>
                      <label>Mobile</label>
                    </div>
                    <div className="email">
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) =>
                          setStateObj({
                            ...stateObj,
                            mobileotp: e.target.value,
                          })
                        }
                        value={stateObj.mobileotp}
                      />
                      <label>Mobile OTP</label>
                    </div>
                    <div className="email">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) =>
                            setStateObj({
                              ...stateObj,
                              email: e.target.value,
                            })
                          }
                          value={stateObj.email}
                        />
                        <div className="input-group-apppend">
                          <span
                            className="input-group-text mt-2"
                            onClick={() => OnSendOtp()}
                          >
                            Send OTP
                          </span>
                        </div>
                      </div>
                      <label>Email</label>
                    </div>
                    <div className="email">
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) =>
                          setStateObj({
                            ...stateObj,
                            otp: e.target.value,
                          })
                        }
                        value={stateObj.otp}
                      />
                      <label>Email OTP</label>
                    </div>
                    <div className="pwd">
                      <input
                        type="password"
                        className="form-control"
                        onChange={(e) =>
                          setStateObj({
                            ...stateObj,
                            password: e.target.value,
                          })
                        }
                        value={stateObj.password}
                      />
                      <label>Password</label>
                    </div>
                    <div className="pwd">
                      <input
                        type="password"
                        className="form-control"
                        onChange={(e) =>
                          setStateObj({
                            ...stateObj,
                            confirmpassword: e.target.value,
                          })
                        }
                        value={stateObj.confirmpassword}
                      />
                      <label>Confirm Password</label>
                    </div>
                    <div className="form-group">
                      <div className="d-md-flex ad-post-details">
                        <label className="custom-control form-checkbox mb-2 me-4">
                          <input
                            id="terms"
                            value="Individual"
                            type="checkbox"
                            className="custom-control-input"
                            checked={stateObj.terms}
                            onChange={(e) =>
                              setStateObj({
                                ...stateObj,
                                terms: stateObj.terms ? false : true,
                              })
                            }
                          />
                          <span
                            className="custom-control-label text-muted"
                            htmlFor="terms"
                          >
                            Agreed to
                            <Link target="_blank" to="/terms">
                              Terms &amp; Conditions.
                            </Link>
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="submit">
                      <button
                        className="btn btn-primary btn-block"
                        type="submit"
                      >
                        Register
                      </button>
                    </div>
                    <p className="text-dark mb-0">
                      Already have an account?
                      <Link to={"/login"} className="text-primary mx-1">
                        Sign IN
                      </Link>
                    </p>
                  </form>
                  {/* <hr className="divider" />
                  <div className="card-body">
                    <div className="text-center">
                      <div className="btn-group">
                        <a
                          href="https://www.facebook.com/"
                          className="btn btn-icon me-2 brround"
                        >
                          <span className="fa fa-facebook"></span>
                        </a>
                      </div>
                      <div className="btn-group">
                        <a
                          href="https://www.google.com/gmail/"
                          className="btn  me-2 btn-icon brround"
                        >
                          <span className="fa fa-google"></span>
                        </a>
                      </div>
                      <div className="btn-group">
                        <a
                          href="https://twitter.com/"
                          className="btn  btn-icon brround"
                        >
                          <span className="fa fa-twitter"></span>
                        </a>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Register;
